// extracted by mini-css-extract-plugin
export default {"login-page":"login_login-page__yGMPy","card":"login_card__TBmXg","logo":"login_logo__7E-qa"};